export default "__VITE_ASSET__Bxy6b4sn__"